var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_362",
    "data-name": "Group 362",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.572,
    height: 16.648,
    viewBox: "0 0 21.572 16.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 21.572,
    height: 16.648,
    fill: "#fdb743"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M21.5,3.775c-.034.25-.061.5-.1.75-.114.724-.238,1.446-.349,2.171-.128.835-.243,1.672-.371,2.507s-.274,1.652-.388,2.481c-.026.187-.075.234-.253.234q-9.257-.006-18.513,0c-.206,0-.253-.1-.275-.259-.062-.446-.119-.893-.188-1.338-.1-.634-.209-1.266-.306-1.9C.645,7.691.545,6.96.434,6.23c-.1-.656-.2-1.313-.311-1.967A2.706,2.706,0,0,1,.082,2.9a.725.725,0,0,1,1.065-.186q2.01,1.515,4.021,3.029a.98.98,0,0,0,1.464-.253Q8.143,3.222,9.659.959c.247-.369.433-.8.9-.958h.405a1.456,1.456,0,0,1,.755.681c.124.211.272.407.408.611.93,1.395,1.854,2.794,2.794,4.183a.929.929,0,0,0,1.385.307c.205-.131.392-.291.587-.438q1.745-1.315,3.491-2.63a.75.75,0,0,1,1.056.127c.238.259.068.852.057.932",
    transform: "translate(0 -0.001)",
    fill: "#fdb743"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M47.183,302.72H29.767c-.018-.041-.059-.036-.092-.051a.931.931,0,0,1-.638-.813c-.024-.718-.014-1.438-.022-2.157,0-.155.1-.136.2-.136.57,0,12.907,0,18.506,0,.2,0,.269.05.264.26-.014.592-.005,1.184-.005,1.776a1.571,1.571,0,0,1-.055.421,1.121,1.121,0,0,1-.741.7",
    transform: "translate(-27.709 -286.072)",
    fill: "#fdb743"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.ab0ce416c6adad3f12610c67c6073b87.svg";
export { ForwardRef as ReactComponent };